<template>
  <div class="aiService">
    <div class="authTip" v-if="!showEmpty && afterLoading">
      <i class="icon icon-authTip"></i>
      <div>
        <p>{{ tip }}</p>
      </div>
    </div>
    <el-table
      :data="tableData"
      tooltip-effect="light"
      style="width: 100%"
      v-if="!showEmpty && afterLoading"
    >
      <el-table-column type="expand">
        <template slot-scope="props">
          <template v-if="props.row.apiTableData.length">
            <div class="expandTitle">
              API列表
            </div>
            <el-table
              :data="props.row.apiTableData"
              size="small"
              tooltip-effect="light"
              style="width: 100%"
              :default-sort="{ prop: 'apiName', order: 'ascending' }"
            >
              <el-table-column
                prop="apiName"
                label="API名称"
                width="200"
                :show-overflow-tooltip="true"
              >
              </el-table-column>
              <el-table-column
                prop="serviceTag"
                label="服务类型"
                :show-overflow-tooltip="true"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="serviceName"
                label="服务"
                :show-overflow-tooltip="true"
                align="center"
                width="160px"
              >
              </el-table-column>
              <el-table-column
                prop="totalCount"
                label="总次数"
                align="center"
                width="120px"
              >
              </el-table-column>
              <el-table-column
                prop="usedCount"
                label="已使用次数"
                align="center"
                width="120px"
              >
              </el-table-column>
              <el-table-column
                prop="restCount"
                label="剩余次数"
                align="center"
                width="120px"
              >
              </el-table-column>
              <el-table-column prop="qps" align="center" width="120px">
                <template slot="header">
                  <span>QPS限制</span>
                  <el-tooltip
                    effect="dark"
                    content="Queries-per-second，每秒请求数"
                    placement="top"
                  >
                    <i class="el-icon-question"></i>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180px" align="center">
                <template slot-scope="scope">
                  <el-button
                    :disabled="scope.row.usedCount === 0"
                    @click="
                      openReportDialog(scope.row.apiName, props.row.clientId)
                    "
                  >
                    报表
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div class="emptyText" v-else>
            此应用未开通任何服务
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="应用名称"
        prop="name"
        width="300px"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="应用描述"
        prop="describe"
        align="left"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        prop="enable"
        label="是否启用"
        align="center"
        width="120px"
      >
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enable" disabled></el-switch>
        </template>
      </el-table-column>
      <el-table-column
        label="有效期限"
        prop="limitTime"
        align="center"
        width="240px"
      >
      </el-table-column>
    </el-table>
    <el-dialog
      v-if="!showEmpty"
      title="报表"
      width="800px"
      :visible.sync="dialogReportVisible"
    >
      <div class="condition">
        <label>时间范围：</label>
        <el-date-picker
          v-model="timeRange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="handleTimeChange"
        >
        </el-date-picker>
      </div>
      <v-chart ref="echarts" :options="barOptions" class="echarts"></v-chart>
    </el-dialog>
    <Empty v-if="showEmpty && afterLoading"></Empty>
  </div>
</template>

<script>
import APIS from "@/apis/aiService.js"
import Base16 from "@/common/base16.js"
import { timeFormat } from "@/common/utils.js"
import Empty from "./empty"

// import { getStore } from "@/common/utils.js"
export default {
  components: {
    Empty
  },
  data() {
    return {
      value1: '',
      tip:
        "欢迎使用方正智+AI服务。管理员可以在当前页查看应用使用AI服务的详情。",
      showEmpty: false,
      afterLoading: false,
      breadcrumb: [
        {
          label: "AI服务"
        }
      ],
      tableData: [],
      enterpriseId: "",
      dialogReportVisible: false,
      barOptions: {
        xAxis: {
          type: "category",
          data: []
        },
        yAxis: {
          type: "value"
        },
        label: {
          show: true,
          position: "top"
        },
        itemStyle: {
          color: "#4497ec"
        },
        tooltip: {
          show: true,
          formatter(params) {
            return `${params.name}<br/>调用成功次数：${params.value}`
          }
        },
        series: [
          {
            data: [],
            barMaxWidth: 40,
            type: "bar"
          }
        ]
      },
      timeRange: []
    }
  },
  mounted() {
    // this.enterpriseId = getStore("enterpriseId")
    // if (this.enterpriseId) {
    //   // this.getEnterpriseAppList()
    // } else {
    //   this.$router.push("/login")
    // }
    let now = Date.now()
    this.timeRange = [
      timeFormat(now - 7 * 24 * 60 * 60 * 1000),
      timeFormat(now)
    ]
    this.getEnterpriseClients()
  },
  beforeDestroy () {
    this.$refs.echarts.clear()
  },
  methods: {
    // 获取应用列表
    async getEnterpriseClients() {
      this.showEmpty = false
      let { status, data } = await APIS.getClients(this.$realm)
      if (status === 0) {
        setTimeout(() => {
          this.afterLoading = true // 弹窗消失后，在橘色展示哪个内容
        }, 500)
        let aiTableData = data && data.list.filter(item => item.mark === "1")
        if (!aiTableData || aiTableData.length === 0) {
          this.showEmpty = true
          return false
        }
        this.tableData = aiTableData.map(item => {
          return {
            id: item.id,
            name: item.name,
            clientId: item.clientId,
            limitTime:
              (item.startDate && item.startDate.split(" ")[0]) +
              " 至 " +
              (item.endDate && item.endDate.split(" ")[0]),
            enable: item.enabled,
            describe: item.description,
            apiTableData: [] // 通过其他接口组装
          }
        })
        this.tableData.forEach(item => {
          this.getClientSercive(item.clientId)
        })
      }
    },
    // 根据应用id，获取应用的服务类型
    async getClientSercive(clientId) {
      let { status, data } = await APIS.getApis(this.$realm, clientId)
      if (status === 0) {
        let currentClient = this.tableData.find(
          item => item.clientId === clientId
        )
        if (currentClient) {
          currentClient.apiTableData = data.map(item => {
            return {
              id: item.id, // 这里的id是api的id
              // pluginId: "", // pluginid，用于设置配额信息的
              apiName: Base16.Decode(item.name),
              serviceTag: Base16.Decode(item.tag).split("-")[0],
              serviceName: Base16.Decode(item.tag).split("-")[1],
              totalCount: item.totalNumber || 0,
              usedCount: item.usedNumber || 0,
              restCount: item.totalNumber - item.usedNumber,
              qps: item.qps || 2
            }
          })
        }
      }
    },
    openReportDialog(apiName, clientId) {
      // 初始化时间
      let now = Date.now()
      this.timeRange = [
        timeFormat(now - 7 * 24 * 60 * 60 * 1000),
        timeFormat(now)
      ]
      this.openReport(apiName, clientId)
    },
    async openReport(apiName, clientId) {
      this.currentApiName = apiName
      this.currentClientId = clientId
      let _this = this
      let start_date = this.timeRange[0]
      let end_date = this.timeRange[1]
      if (typeof start_date !== "string") {
        start_date = timeFormat(start_date)
        end_date = timeFormat(end_date)
      }
      start_date = start_date.split(" ")[0] + " 00:00:00"
      end_date = end_date.split(" ")[0] + " 23:59:59"
      let params = {
        custom_id: clientId,
        route_name: Base16.Encode(apiName),
        start_date,
        end_date
      }
      let { status, data } = await APIS.getReport(this.$realm, { params })
      if (status === 0) {
        setTimeout(() => {
          _this.dialogReportVisible = true
        }, 1000)
        _this.dialogReportVisible = true
        if (data && data.length) {
          this.barOptions.xAxis.data = data.map(item => item.date)
          this.barOptions.series[0].data = data.map(item => item.sum)
        } else {
          this.barOptions.xAxis.data = []
          this.barOptions.series[0].data = []
        }
      }
    },
    // 时间改变
    handleTimeChange() {
      if (this.timeRange === null) {
        this.barOptions.xAxis.data = []
        this.barOptions.series[0].data = []
      }
      this.openReport(this.currentApiName, this.currentClientId)
    }
  }
}
</script>

<style lang="scss">
.aiService {
  .authTip {
    display: flex;
    background-color: rgba(0, 112, 204, 0.05);
    font-size: 13px;
    color: #454647;
    padding: 10px;
    line-height: 22px;
    margin-bottom: 15px;
    align-items: center;
    i {
      margin-right: 10px;
      margin-left: 5px;
    }
  }
  .el-table {
    &__row {
      &.expanded {
        // background-color: #d6eafe;
      }
    }
    &__expanded-cell {
      font-size: 14px;
      color: #333333;
      font-weight: 400;
      padding: 20px;
      background-color: #d6eafe;
      &:hover {
        background-color: #d6eafe !important;
        .expandTitle {
          color: #333333;
        }
        .emptyText {
          color: #333333;
        }
      }
      .expandTitle {
        font-weight: 600;
        margin-bottom: 10px;
      }
      .emptyText {
        color: #333333;
        font-size: 12px;
      }
      .el-button {
        border: none;
        color: #4497ec;
        &:hover {
          background-color: transparent;
        }
      }
      th {
        .el-tooltip {
          position: absolute;
          top: 5px;
          margin-left: 6px;
        }
      }
    }
  }
  .echarts {
    width: 100%;
    height: 300px;
  }
  .el-range-editor.el-input__inner {
    width: 310px;
    margin-left: 10px;
  }
  .el-date-editor .el-range__close-icon {
    margin-top: -10px;
  }
}
</style>
